import React from 'react';
import { IAreaIdsByType } from 'modules/timeAndExpense/components/WorkingPage/store/selectors';

export const IgnoredAreasByType = React.createContext<IAreaIdsByType | null>(null);
